var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBackStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16L9.41 14.59L3.83 9L16 9V7L3.83 7L9.42 1.42L8 0L0 8L8 16Z",
    fill: "#0F82ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackStep);
export default __webpack_public_path__ + "static/media/ArrowBackStep.97a20236afaf790df0ed7bd1cc3ff9b5.svg";
export { ForwardRef as ReactComponent };